import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Pre from "./components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ProjectDetails from "./components/Projects/ProjectDetails";
import Analytics from "./components/analytics/analytics";
import "./App.css";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";
function App() {
  const [load, updateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      updateLoad(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Pre load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projectDetails/:id" element={<ProjectDetails />} />
          <Route path="/analytics" element={<Analytics />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

